import { gql } from '@apollo/client';

import APPOINTMENTS_FRAGMENT from '../fragments/appointments';
import META_FRAGMENT from '../fragments/meta';

export const GET_APPOINTMENTS = gql`
  ${META_FRAGMENT}
  ${APPOINTMENTS_FRAGMENT}
  query findAppointmentEntity(
    $pagination: PageOptionsDto
    $id: String
    $status: String
    $query: String
    $state: String
    $order: AppointmentSortFields
    $priorityId: String
    $fromDate: DateTime
    $toDate: DateTime
    $locationIds: [String!]
    $onlyMine: Boolean
  ) {
    findAppointmentEntity(
      pagination: $pagination
      id: $id
      status: $status
      query: $query
      state: $state
      order: $order
      priorityId: $priorityId
      fromDate: $fromDate
      toDate: $toDate
      locationIds: $locationIds
      onlyMine: $onlyMine
    ) {
      data {
        ...AppointmentsFragment
        distance
        files {
          details
          name
          path
          pipeFrom
          id
          status
        }
        transaction {
          reference
          requiredScanDoc
          id
          transactionType {
            id
          }
          createdBy {
            id
            firstName
            lastName
            avatar {
              id
              thumbnailPipeFrom
            }
            company {
              name
            }
          }
          assigners {
            id
            firstName
            lastName
            avatar {
              id
              thumbnailPipeFrom
            }
            company {
              name
            }
          }
          signatories
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

const ACTIVE_APPOINTMENTS_FRAGMENT = gql`
  ${META_FRAGMENT}
  ${APPOINTMENTS_FRAGMENT}
  fragment ActiveAppointmentsFragment on AppointmentEntityPageDto {
    data {
      ...AppointmentsFragment
      distance
      documentStatus
      files {
        details
        name
        path
        pipeFrom
        id
        status
      }
      transaction {
        requiredScanDoc
        id
        transactionType {
          id
        }
        assigners {
          id
          firstName
          lastName
          avatar {
            id
            thumbnailPipeFrom
          }
        }
        signatories
      }
      chatRoom {
        id
        unreadMessagesCount
      }
      scannedFiles {
        id
        name
      }
      labelFiles {
        id
        name
      }
    }
    meta {
      ...MetaFragment
    }
  }
`;

export const GET_ACTIVE_APPOINTMENTS_FOR_NOTARY = gql`
  ${ACTIVE_APPOINTMENTS_FRAGMENT}
  query findAppointmentEntity(
    $pagination: PageOptionsDto
    $status: String
    $documentStatus: String
    $query: String
    $state: String
    $order: AppointmentSortFields
    $priorityId: String
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    findAppointmentEntity: findAppointmentEntityWithDistance(
      status: $status
      documentStatus: $documentStatus
      query: $query
      state: $state
      order: $order
      priorityId: $priorityId
      fromDate: $fromDate
      toDate: $toDate
      pagination: $pagination
    ) {
      ...ActiveAppointmentsFragment
    }
  }
`;

export const GET_OVERDUE_APPOINTMENTS_FOR_NOTARY = gql`
  ${ACTIVE_APPOINTMENTS_FRAGMENT}
  query findAppointmentEntity(
    $pagination: PageOptionsDto
    $id: String
    $status: String
    $query: String
    $state: String
    $order: AppointmentSortFields
    $priorityId: String
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    findOverdueAppointments: findAppointmentEntityWithDistance(
      pagination: $pagination
      id: $id
      status: $status
      query: $query
      state: $state
      order: $order
      priorityId: $priorityId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      ...ActiveAppointmentsFragment
    }
  }
`;
